<template>
  <div>
    <div class="header">处方前置审核</div>
   <div style=" position:absolute; height:80%;width: 100%;overflow:scroll;">
     <div class="content" v-for="(item,index) in cardLit" :key="index">
        <div class="icon" ><van-icon name="warning" :color="{1:'rgb(253,217,11)',2:'red',3:'orange',4:'black'}[item.caution]" size=30 /></div>
        <div style="margin-left:10px">
            <p style="font-size:20px">{{item.commonName}}</p>
            <br>
           <div v-for="(list,index) in item.list" :key="index">
             <p><span>{{list.cautionStr}}</span>&nbsp;&nbsp;<span>{{list.limitTypeStr}}</span></p>
             
             <p style="white-space: pre-wrap;">{{list.desc}} </p>
              <br>
           </div>
        </div>
    </div>
   </div>
    <div class="bottom">
        <van-button type="primary" class="buttonConfig" @click="goBack" >调整信息</van-button>
        <van-button type="primary" class="buttonConfig" @click="next" v-if="!cardLit.find(item=>{return item.caution==4})">继续提交</van-button>
    </div>
  </div>
</template>

<script>
export default {
name:"intercept",
props:{
  cardLit:{
    type:Array,
    default:()=>{
      return []
    }
  }
},
methods:{
  goBack(){
    this.$emit("goBack")
  },
  next(){
     this.$emit("next")
  }
}
}
</script>

<style lang="scss" scoped>
.header{
    font-size: 18px;
    padding: 5px 18px;
    background-color: rgb(240,240,241);
}

.content{
    margin-top: 10px;
    padding: 5px 10px;  
     display: flex;
    font-size: 15px;
   
}
.bottom{
    position: absolute;
    width: 100%;
    bottom: 10px;
    display: flex;
    justify-content: space-around;
    .buttonConfig{
        width: 120px;
        height: 30px;

    }
}
</style>